export const cilMediaPlay = ["24 24","<path d='M20.831 11.027l-14.631-8.709c-0.164-0.1-0.363-0.158-0.576-0.158-0.621 0-1.125 0.504-1.125 1.125v0 17.069c0 0 0 0 0 0 0 0.621 0.504 1.125 1.125 1.125 0.205 0 0.398-0.055 0.564-0.151l-0.005 0.003 14.629-8.36c0.341-0.198 0.567-0.561 0.567-0.977 0-0.409-0.218-0.767-0.544-0.964l-0.005-0.003zM6 19.708v-15.764l13.511 8.043z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-media-play.js
// module id = null
// module chunks = 